import * as React from "react";
import { isEqual, startOfWeek } from "date-fns";
import { Control, useWatch } from "react-hook-form";
import { useEffect, useState } from "react";
import { VIEW_OWN_SCHEDULED_ONLY } from "constants/permissions";
import useUserRoles from "hooks/use-user-roles.hook";
import { AppointmentFormValues } from "../appointment-form.component";
import StaffAvailabilityHeader from "./staff-availability-header";
import AvailableStaffFilter from "./available-staff-filter.component";
import StaffAvailabilityList from "./staff-availability-list";
import StaffAvailabilitySettings from "./staff-availability-settings";
import Stack from "@mui/material/Stack";

type StaffAvailabilityProps = {
  control: Control<AppointmentFormValues, object>;
  setValue: (name: any, value: any, options?: any) => void;
  visible: boolean;
  defaultShowFilter?: boolean;
};

export default function StaffAvailability({
  control,
  setValue,
  visible,
  defaultShowFilter = false,
}: StaffAvailabilityProps) {
  const [showFilter, setShowFilter] = useState<boolean>(defaultShowFilter);
  const appointmentDate = useWatch({ control, name: "appointment_date" });
  const [fromDate, setFromDate] = useState<Date>(
    startOfWeek(appointmentDate || new Date())
  );
  const [appointmentDateApplied, setAppointmentDateApplied] = useState<Date>(
    appointmentDate || new Date()
  );
  const { userPermissions } = useUserRoles();
  const viewOwnScheduleOnly = userPermissions[VIEW_OWN_SCHEDULED_ONLY];
  useEffect(() => {
    if (
      appointmentDate &&
      !isEqual(fromDate, startOfWeek(appointmentDate)) &&
      !isEqual(appointmentDate, appointmentDateApplied)
    ) {
      setFromDate(startOfWeek(appointmentDate));
      setAppointmentDateApplied(appointmentDate);
    }
  }, [appointmentDate, fromDate, appointmentDateApplied]);
  return (
    <Stack
      sx={{
        width: "100%",
      }}
    >
      <StaffAvailabilityHeader
        fromDate={fromDate}
        setFromDate={setFromDate}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
      />
      {!viewOwnScheduleOnly && <AvailableStaffFilter showFilter={showFilter} />}
      <StaffAvailabilityList
        control={control}
        setValue={setValue}
        visible={visible}
        fromDate={fromDate}
      />
      <StaffAvailabilitySettings />
    </Stack>
  );
}
